import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { clientSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import ImageUploadDragAndDrop from "../../../Components/ImageUploadDragAndDrop";
import { CheckSquare, Square } from "lucide-react";

const AddClient = () => {
  const navigator = useNavigate();
  const { clientTypeId } = useParams();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    image: editData?.image || "",
    sortOrder: editData?.sortOrder || 1,
    clientTypeId: clientTypeId,
    name: editData?.name || "",
    location: editData?.location || "",
    isActive: editData?.isActive,
    showInHome: editData?.showInHome
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
    useFormik({
      initialValues: initalvalues,
      validationSchema: clientSchema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const formData = new FormData();

          formData.append("sortOrder", values.sortOrder);
          formData.append("clientTypeId", values.clientTypeId);
          formData.append("location", values.location);
          formData.append("name", values.name);
          formData.append("isActive", values.isActive || false);
          formData.append("showInHome", values.showInHome || false);
          if (values.image instanceof File) {
            formData.append("image", values.image);
          }
          const response = editingId
            ? await axiosInstance.put(
              `/client/updateClient/${editingId}`,
              formData,
            )
            : await axiosInstance.post("/client/createClient", formData);

          if (response.status === 200) {
            toast.success(response.data.message);
            navigator(`/clients/${clientTypeId}`);
          }
        } catch (error) {
          toast.error(error.response?.data?.message);
          return error;
        } finally {
          setLoading(false);
        }
      },
    });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Client Type", path: "/client-type" },
    { label: "Clients", path: `/clients` },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Client
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="client-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="client-sortOrder"
                        name="sortOrder"
                        placeholder="Enter client Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">

                      <label
                        htmlFor="clientType-name"
                        className="col-form-label"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        className="border border-dark form-control"
                        id="clientType-name"
                        name="name"
                        placeholder="Enter Client Type Name"
                        value={values.name}
                        onChange={handleChange}
                      />
                      {touched.name && errors.name && (
                        <small className="text-danger">
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6 mt-3">
                    <div className="form-group">
                      <label
                        htmlFor="client-location"
                        className="col-form-label"
                      >
                        Location
                      </label>
                      <input
                        type="text"
                        className="border border-dark form-control"
                        id="client-location"
                        name="location"
                        placeholder="Enter Client Location"
                        value={values.location}
                        onChange={handleChange}
                      />
                      {touched.location && errors.location && (
                        <small className="text-danger">
                          {errors.location}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="slider-image"
                      label={`Client Image`}
                      value={values.image}
                      onChange={(file) => setFieldValue("image", file)}
                      error={errors.image}
                      touched={touched.image}
                    />
                  </div>

                  <div className="col-md-6 mt-4">
                    <div className="d-flex flex-column mb-3 " style={{ gap: "10px" }}>
                      <div className={`menu-row p-4 ${values.showInHome ? "active" : "inActive"}`}
                        onClick={() =>
                          setFieldValue("showInHome", !values.showInHome)
                        }
                      >
                        {values.showInHome ? (
                          <CheckSquare size={20} className="icon-active" />
                        ) : (
                          <Square size={20} className="icon" />
                        )}
                        <span className="menu-title">Show In Home</span>
                      </div>
                    </div>

                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to={`/clients/${clientTypeId}`}>
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClient;
